import ShopStatusPage from "../components/ShopStatusPage";

const NotFound = () => <ShopStatusPage message="The page you are looking for does not exist." />;

export default NotFound;
